import { render, staticRenderFns } from "./create-candidate-form.html?vue&type=template&id=08a2f09e&scoped=true&external"
import script from "./create-candidate-form.js?vue&type=script&lang=js&external"
export * from "./create-candidate-form.js?vue&type=script&lang=js&external"
import style0 from "./create-candidate-form.scss?vue&type=style&index=0&id=08a2f09e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a2f09e",
  null
  
)

export default component.exports